// extracted by mini-css-extract-plugin
export default {"container":"footer_container__8v-7E","createLink":"footer_createLink__IstSh","logo":"footer_logo__luaRk","separator":"footer_separator__GsAD+","content":"footer_content__3ol3A"};